var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g3, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyKlosetIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 51,
    viewBox: "0 0 61 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8877 25.7894L56.3025 15.8971L46.3845 27.2895L44.8877 25.7894Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_159_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 0,
    width: 52,
    height: 51
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5957 0H60.332V50.8625H9.5957V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_159_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5986 32.5767L42.4896 29.6916",
    stroke: "#333333",
    strokeWidth: 9.54223,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3128 29.4678C43.5785 29.621 42.8588 29.1516 42.7049 28.4167C42.5518 27.6831 43.0218 26.9633 43.756 26.8095C44.4896 26.6557 45.2094 27.1263 45.3626 27.8599C45.517 28.5935 45.0464 29.314 44.3128 29.4678ZM43.3761 24.9952C41.6394 25.3594 40.5272 27.0613 40.8913 28.7973C41.2548 30.5333 42.9574 31.6449 44.6927 31.2814C46.4288 30.9179 47.541 29.216 47.1775 27.48C46.8133 25.7439 45.1115 24.6317 43.3761 24.9952Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_159_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 6,
    width: 40,
    height: 45
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7119 6.35889H60.3321V50.7847H21.7119V6.35889Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_159_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8855 6.46991C35.9898 7.02405 30.6621 9.84143 26.8856 14.4014C23.1079 18.9621 21.3324 24.7204 21.8865 30.6161C22.8252 40.5985 30.2795 48.4274 39.6446 50.2904C41.6988 50.6992 43.8444 50.8202 46.0334 50.6151C47.5222 50.4751 48.969 50.1937 50.3698 49.7717C50.1503 49.422 49.9807 49.0361 49.8696 48.6266C48.4018 48.9349 46.8945 49.0828 45.5003 49.023C34.8907 48.5688 25.78 40.9153 24.7874 30.3439C24.3055 25.2226 25.8477 20.2209 29.1285 16.2597C32.4093 12.2979 37.037 9.85194 42.1577 9.37011C48.2236 8.8002 53.8472 10.5428 57.9109 15.0943L60.3371 13.5331C55.6595 8.2947 48.8685 5.81389 41.8855 6.46991Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5112 8.30557L18.7109 7.43854L42.4903 6.44727L39.5112 8.30557Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9753 29.6826L6.00488 28.8155L23.9753 27.9485V29.6826Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4625 50.6464L0 49.3357L38.5729 48.1169L41.4625 50.6464Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4569 40.1914L8.85059 39.5531L26.4569 38.9155V40.1914Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0291 18.7409L14.7715 18.104L26.0291 17.4657V18.7409Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2114 24.1754L12.9531 23.5378L24.2114 22.8995V24.1754Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4076 34.8355L7.01172 34.1972L24.4076 33.5596V34.8355Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3169 45.428L5.50488 44.7904L30.3169 44.1521V45.428Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3172 13.364L19.0596 12.727L30.3172 12.0887V13.364Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_159_1377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 0,
    width: 6,
    height: 4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0645 0H46.9542V3.16182H41.0645V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_159_1377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3866 3.09693H41.5223C41.2889 3.09693 41.0996 2.90827 41.0996 2.67557V0.436662C41.0996 0.203306 41.2889 0.0146484 41.5223 0.0146484H46.3866C46.62 0.0146484 46.8086 0.203306 46.8086 0.436662V2.67557C46.8086 2.90827 46.62 3.09693 46.3866 3.09693Z",
    fill: "black"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3796 5.92364H42.5273V3.51514H45.3796V5.92364Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4889 14.8326L35.3596 12.8757L34.6924 13.2616L35.821 15.2192C36.0406 15.0851 36.2628 14.9562 36.4889 14.8326Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9581 12.9326C44.0876 12.9326 44.2158 12.9398 44.3446 12.9425L44.3453 10.6766L43.5749 10.6753L43.5742 12.9425C43.7017 12.9392 43.8293 12.9326 43.9581 12.9326Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6357 20.4043L28.6782 19.2737L28.293 19.9409L30.2499 21.0709C30.3728 20.8454 30.5016 20.6232 30.6357 20.4043Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0959 15.2211L53.2259 13.2642L52.5593 12.879L51.4287 14.8353C51.6548 14.9589 51.8764 15.087 52.0959 15.2211Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3475 28.5427C28.3475 28.4132 28.3547 28.2844 28.3573 28.1556L26.0915 28.1549L26.0908 28.9253L28.3573 28.926C28.3547 28.7984 28.3475 28.6709 28.3475 28.5427Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2469 36.01L28.29 37.14L28.6759 37.8078L30.6335 36.6772C30.4994 36.459 30.3705 36.2361 30.2469 36.01Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9581 44.1517C43.828 44.1517 43.6998 44.1445 43.5703 44.1418V46.4077L44.3407 46.409V44.1425C44.2132 44.1445 44.0863 44.1517 43.9581 44.1517Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8191 41.8638L34.6885 43.8213L35.3563 44.2065L36.4857 42.2496C36.2602 42.1274 36.038 41.9979 35.8191 41.8638Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyKlosetIcon2);
export default __webpack_public_path__ + "static/media/whyKlosetIcon2.a3728642f6606f471582a4eb148a9a06.svg";
export { ForwardRef as ReactComponent };